import { ref } from "vue";

export const dashIconsList = ref([]);
